import { readingTimeActions } from '../actions'
import ValidateFormObject from '../utils/ValidateFormObject'
const {
  READING_TIME_FETCH,
  READING_TIME_FETCHING,
  READING_TIME_FETCH_ERROR,
  READING_TIME_OPEN_MODAL,
  READING_TIME_CLOSE_MODAL,
  READING_TIME_CHANGE,
  READING_TIME_DELETE,
  READING_TIME_ADD,
  READING_TIME_EDIT,
  READING_TIME_FORM_TOUCHED,
  READING_TIME_NEW_FORM,
  READING_TIME_FORM_ERROR,
  READING_TIME_CHANGE_PAGE,
  READING_TIME_CHANGE_PER_PAGE,
  READING_TIME_CHANGE_ORDER_COLUMN,
  READING_TIME_CHANGE_ORDER_DIRECTION,
  READING_TIME_RESET_STATE,
  READING_TIMES_FETCH,
  READING_TIMES_FETCH_ALL,
  READING_TIMES_FETCHING,
  READING_TIMES_FETCH_ERROR,
  READING_TIME_FETCH_RANGES,
  READING_TIME_FETCHING_RANGES,
  READING_TIME_FETCH_RANGES_ERROR
} = readingTimeActions

const initialState = {
  loading: false,
  loadingList: false,
  fetchError: false,
  fetchListError: false,
  list: [],
  order: {
    column: 'nome',
    direction: 1
  },
  selected: {
    nome: '',
    chave: '',
    tempo: [0, 20]
  },
  originalRange: [],
  pagination: {
    page: 0,
    rowsPerPage: 50,
    length: 0
  },
  formErrors: {},
  formTouched: false,
  modalOpen: false,
  ranges: [],
  loadingRanges: false,
  fetchRangeError: false,
  formSchemaType: null
}

const validationSchema = {
  add: {
    nome: {
      required: true
    },
    chave: {
      required: true
    },
    tempo: {
      required: false
    }
  },
  edit: {
    nome: {
      required: true
    },
    chave: {
      required: true
    },
    tempo: {
      required: false
    }
  }
}

const ReadingTimeValidate = new ValidateFormObject(validationSchema)

export default (state = initialState, action = {}) => {
  let formSchemaType
  switch (action.type) {
    case READING_TIME_CHANGE:
      formSchemaType = action.readingTime._id ? 'edit' : 'add'
      return {
        ...state,
        formSchemaType,
        selected: action.readingTime,
        formErrors: ReadingTimeValidate.validate({
          formObject: action.readingTime,
          formSchemaType
        })
      }
    case READING_TIME_FORM_ERROR:
      const formErrors = {}
      formSchemaType = state.selected._id ? 'edit' : 'add'
      formErrors[action.field] = { valid: false, errorMessage: action.message }
      return {
        ...state,
        formSchemaType,
        formErrors: ReadingTimeValidate.validate({
          formObject: state.selected,
          invalidFields: formErrors,
          formSchemaType
        })
      }
    case READING_TIME_NEW_FORM:
      return {
        ...state,
        formSchemaType: 'add',
        selected: { ...initialState.selected },
        originalRange: [],
        formErrors: ReadingTimeValidate.validate({}),
        formTouched: false
      }
    case READING_TIME_FORM_TOUCHED:
      return {
        ...state,
        formTouched: true
      }
    case READING_TIME_OPEN_MODAL:
      return {
        ...state,
        modalOpen: true
      }
    case READING_TIME_CLOSE_MODAL:
      return {
        ...state,
        modalOpen: false
      }
    case READING_TIME_FETCH:
      formSchemaType = (action.readingTime || {})._id ? 'edit' : 'add'
      return {
        ...state,
        formSchemaType,
        selected: action.readingTime,
        originalRange: action.readingTime.tempo,
        loading: false,
        fetchError: false,
        formTouched: false,
        formErrors: ReadingTimeValidate.validate({
          formObject: action.readingTime,
          formSchemaType
        })
      }
    case READING_TIME_FETCHING:
      return {
        ...state,
        loading: true,
        fetchError: false
      }
    case READING_TIME_DELETE:
      return {
        ...state,
        loadingList: false,
        fetchError: false,
        list: state.list.filter(readingTime => readingTime._id !== (action.readingTime || {})._id)
      }
    case READING_TIME_FETCH_ERROR:
      return {
        ...state,
        loadingList: false,
        selected: { ...initialState.readingTime },
        fetchError: action.error
      }
    case READING_TIME_CHANGE_ORDER_COLUMN:
      return {
        ...state,
        order: {
          direction: 1,
          column: action.column
        }
      }
    case READING_TIME_CHANGE_ORDER_DIRECTION:
      return {
        ...state,
        order: {
          ...state.order,
          direction: action.direction
        }
      }
    case READING_TIME_CHANGE_PAGE:
      return {
        ...state,
        pagination: {
          ...state.pagination,
          page: action.page
        }
      }
    case READING_TIME_CHANGE_PER_PAGE:
      return {
        ...state,
        pagination: {
          ...state.pagination,
          rowsPerPage: action.perPage
        }
      }
    case READING_TIMES_FETCH:
      return {
        ...state,
        loadingList: false,
        list: action.items,
        fetchListError: false,
        order: action.order,
        pagination: {
          length: action.length,
          page: action.page,
          rowsPerPage: action.rowsPerPage
        }
      }
    case READING_TIMES_FETCH_ALL:
      return {
        ...state,
        list: action.readingTimes
      }
    case READING_TIME_EDIT:
      return {
        ...state,
        list: state.list.map(readingTime => {
          if (readingTime._id === action.readingTime._id) {
            return action.readingTime
          }
          return readingTime
        }),
        loadingList: false,
        fetchError: false,
        loading: false,
        fetchListError: false
      }
    case READING_TIMES_FETCHING:
      return {
        ...state,
        loadingList: true,
        fetchListError: false
      }
    case READING_TIMES_FETCH_ERROR:
      return {
        ...state,
        loadingList: false,
        fetchListError: action.error,
        loading: false
      }
    case READING_TIME_ADD:
      return {
        ...state,
        loadingList: false,
        fetchListError: false,
        loading: false,
        list: [...state.list, action.readingTime]
      }
    case READING_TIME_FETCH_RANGES:
      return {
        ...state,
        ranges: action.ranges,
        loadingRanges: false,
        fetchRangeError: false
      }
    case READING_TIME_FETCH_RANGES_ERROR:
      return {
        ...state,
        loadingRanges: false,
        fetchRangeError: action.error
      }
    case READING_TIME_FETCHING_RANGES:
      return {
        ...state,
        loadingRanges: true,
        fetchRangeError: false
      }
    case READING_TIME_RESET_STATE:
      return initialState
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/readingTimes.js